import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Gift, Utensils, Zap, ShieldCheck, Smartphone } from 'lucide-react';
export function SocialProof() {
  const metrics = [{
    icon: BookOpen,
    text: '+100 recetas incluidas'
  }, {
    icon: Gift,
    text: '+3 bonus exclusivos'
  }, {
    icon: Utensils,
    text: 'Miles de comidas posibles'
  }, {
    icon: Zap,
    text: 'Acceso inmediato'
  }, {
    icon: ShieldCheck,
    text: 'Garantía de 7 días'
  }, {
    icon: Smartphone,
    text: 'Compatible con celular, tablet y computadora'
  }];
  return <section className="py-12 bg-gray-50 border-y border-gray-100" data-id="element-183">
      <div className="max-w-6xl mx-auto px-6" data-id="element-184">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 md:gap-8" data-id="element-185">
          {metrics.map((metric, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex flex-col items-center text-center space-y-3" data-id="element-186">
              <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center text-primary" data-id="element-187">
                <metric.icon className="w-6 h-6" data-id="element-188" />
              </div>
              <span className="text-sm font-medium text-gray-600 leading-tight" data-id="element-189">
                {metric.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}